import delimiter from "./delimiter";
import type { OutgoingMessage } from "./types";

export default function serializeMessage({
  type,
  body,
}: OutgoingMessage): string {
  return `${type}${delimiter.section}${body || ""}${delimiter.endOfMessage}`;
}
